import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiErrorDetail, formatLoginError, setToken, clearToken } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = unauth, obj = authed

  const [authError, setAuthError] = useState("");
  const refresh = useCallback(async () => {
    setAuthError("");
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (err) {
      if ([401,403].includes(err.response?.status)) { clearToken(); setUser(false); }
      else { setAuthError(formatLoginError(err)); }
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password, code) => {
    const { data } = await api.post("/auth/login", { email, password, code });
    if (data.mfa_required) return data;
    setAuthError("");
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    clearToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refresh, authError }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export { formatApiErrorDetail };

